module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"account-tabs:user-info":"Информация о пользователе","account-tabs:account-security":"Безопасность"},"en":{"account-tabs:user-info":"User Information","account-tabs:account-security":"Security"}}')
  delete Component.options._Ctor
}
